import apiClient from '@/utils/api-client-without-base-url';

const suffixEndpoint = '/users/user-roles';

export default {
  getAll: () => apiClient.get(suffixEndpoint),
  get: id => {
    return apiClient.get(`${suffixEndpoint}/${id}`);
  },
  create: data => {
    return apiClient.post(suffixEndpoint, data);
  },
  edit: data => {
    const { id: categoryId } = data;
    
    delete data["id"];

    return apiClient.put(`${suffixEndpoint}/${categoryId}`, data);
  },
  delete: id => {
    return apiClient.delete(`${suffixEndpoint}/${id}`);
  },
};
